import { Link } from "react-router-dom";

export function AdminAutomotiveNav({ active = "dashboard" }) {
  const items = [
    { key: "dashboard", label: "Dashboard", href: "/admin/dashboard" },
    { key: "dealers", label: "Concesionarios", href: "/admin/dealers" },
    { key: "prospects", label: "Prospectos", href: "/admin/dealers/prospects" },
    { key: "verifications", label: "Verificaciones", href: "/admin/dealers/verifications" },
    { key: "trials", label: "Trials", href: "/admin/dealers/trials" },
    { key: "plans", label: "Planes", href: "/admin/plans" },
    { key: "placements", label: "Destacados", href: "/admin/placements" },
    { key: "expansion", label: "Expansión", href: "/admin/expansion" },
    { key: "partners", label: "Aliados", href: "/admin/partners" },
    { key: "listings", label: "Inventario", href: "/admin/listings" },
    { key: "inventory-quality", label: "Calidad", href: "/admin/inventory-quality" },
    { key: "listing-identity", label: "Identidad", href: "/admin/vehicle-listing-identity" },
    { key: "imports", label: "Importaciones", href: "/admin/inventory/imports" },
    { key: "leads", label: "Leads", href: "/admin/leads" },
    { key: "seller-submissions", label: "Solicitudes vendedores", href: "/admin/seller-submissions" },
    { key: "campaigns", label: "Campañas", href: "/admin/campaigns" },
    { key: "playbook", label: "Playbook", href: "/admin/playbook" },
    { key: "trust-safety", label: "Confianza", href: "/admin/trust-safety" },
    { key: "analytics", label: "Analytics", href: "/admin/analytics/buyers" },
  ];

  return (
    <nav className="admin-console__nav-tabs admin-automotive-nav">
      {items.map((item) =>
        item.disabled ? (
          <span key={item.key} className="admin-automotive-nav__disabled" title="Próximamente">
            {item.label}
          </span>
        ) : (
          <Link
            key={item.key}
            to={item.href}
            className={active === item.key ? "is-active" : undefined}
          >
            {item.label}
          </Link>
        )
      )}
    </nav>
  );
}
